import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/other/Loader";
import HeroSection from "../../layout/HeroSection";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../components/other/NoRecord";
import { fetchEmbeds } from "../../redux/action/embedActions";
import { fetchSubscriptions } from "../../redux/action/moreAction";
import { curSym, pipGetAccessToken } from "../../utils/pip";
import { message } from "antd";
const Curriculum = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tabs = [
    {
      label: "Monthly",
      value: "monthly",
    },
    {
      label: "Yearly",
      value: "yearly",
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]?.value);

  const { isLoading1, aboutData, subscriptionsList } = useSelector(
    (state) => state.moreReducer
  );

  useEffect(() => {
    dispatch(fetchEmbeds());
    dispatch(fetchSubscriptions());
  }, []);

  const hanldeSubscription = () => {
    const token = pipGetAccessToken();

    if (token) {
      message.error("Students are not allowed to purchase subscriptions.");
    } else {
      navigate(pageRoutes?.login, {
        state: {
          data: activeTab,
        },
      });
    }
  };
  if (isLoading1) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 class="mb-3">{"Curriculum"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}` },
          {
            name: "Curriculum",
            path: `${pageRoutes?.home}`,
          },
        ]}
        banner_image={aboutData?.about_banner}
      />
      <section className="untree_co-section pt-5 pb-5 ">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <ul class="nav nav-pills mb-3 ct_pricing_tabs ct_pricing_tabs mb-4">
                  {tabs?.map((item, index) => (
                    <li
                      key={index}
                      class="nav-item"
                      onClick={() => setActiveTab(item?.value)}
                      role="presentation"
                    >
                      <button
                        class={`nav-link ${
                          activeTab == item?.value ? "active" : ""
                        }`}
                        type="button"
                      >
                        {item?.label}
                      </button>
                    </li>
                  ))}
                </ul>

                <div class="row">
                  {subscriptionsList?.length > 0 ? (
                    subscriptionsList?.map((item, index) => (
                      <div class="col-md-6 col-lg-3">
                        <div class="ct_pricing_card h-100">
                          <h4 class="ct_fs_16 ct_fw_600">
                            {item?.name || "#N/A"}
                          </h4>
                          <p class="text-muted">
                            For {item?.user_access_count > 1 && "up to"}{" "}
                            {item?.user_access_count || 0} user
                            {item?.user_access_count > 1 && "s"}
                          </p>
                          <h3 class="fw-bold ct_yellow_clr ">
                            {curSym} {item?.[activeTab + "_price"]}
                            <span class="fs-6">/{[activeTab]}</span>
                          </h3>
                          <ul class="list-unstyled">
                            <li>
                              <div>
                                <p>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.description || "",
                                    }}
                                  />
                                </p>
                              </div>
                            </li>
                          </ul>
                          <a
                            href="javascript:void(0)"
                            onClick={hanldeSubscription}
                            class="et_btn22 btn-secondary ct_btn_animate22 w-100 mt-3"
                          >
                            Buy Now
                          </a>
                        </div>
                      </div>
                    ))
                  ) : (
                    <NoRecord />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Curriculum;
